module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_eight_black_vertical-1ca070633cfdd5e2a686039867d381ae.svg";